import React, { useEffect, useState } from 'react';
import {Breadcrumb, Button,  Col,Form,FormControl,InputGroup,Nav, Row,Tab, Table} from "react-bootstrap";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import dummy_img from '../../../assets/images/dummy.png';
import member5 from '../../../assets/images/member5.png';
import close from '../../../assets/images/icons/close.svg';

import { BACKEND_DOMAIN } from '../../../config/variables';
import { GET, POST } from '../../../utils/axios.util';

function CoordinatorAddDivision(){

    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    const navigate = useNavigate();
    const currentUser = useSelector(state => state.authenticate)
    const [ isLoading, setIsLoading ] = useState(false)

    useEffect(() => {
        // Pre-fill form with current coordinator info
        if(currentUser && currentUser.id) {
            // Coordinator will be auto-selected in onSubmit
        }
    },[])



    const onSubmit = (data) => {

        // Auto-select current coordinator only
        if(currentUser && currentUser.id) {
            data = { ...data, coordinator_ids: JSON.stringify([currentUser.id.toString()]) }
        }

        let payload = {
            url : `${BACKEND_DOMAIN}/school/divisions/create`,
            data
        }

        setIsLoading(true)
        POST(payload).then(res => {

            setIsLoading(false)
            toast.success(res.data.message)
            navigate('/coordinator/divisions')

        }).catch(err => {

            if(err.response && err.response.status === 401) {
                toast.error('Session Expired! Logging out...', { autoClose: 2000 })
                setTimeout(() => {
                    window.location.reload();
                }, 1000)
            }

            setIsLoading(false)
            if(err.response.status === 403) {
                toast.error(err.response.data.message)
            }
        })
    }

    return(
        <>        

            <h2 className="page_hdng">Add Class</h2>

            { isLoading && 
                <div className='text-center subscriptions_packages_name no_records_loading'>
                    <h5>Loading...</h5>
                </div>
            }
            { !isLoading &&
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <div className='my_card mt-4'>
                        <Row>
                            <Col>
                                <div className="my_card_brand_dark_color">
                                    <div className='d-flex align-items-center justify-content-end'>
                                        <NavLink to="/coordinator/divisions">
                                            <Button variant='trans_success'>Back</Button>
                                        </NavLink>
                                    </div>
                                    <div className='d-flex align-items-center justify-content-center'>
                                        <h5 className='fs-20 fw-500 text-center'>Enter Details</h5>
                                    </div>
                                    <Row>
                                        <Col lg="10">
                                            <Row>
                                                <Col sm="6">
                                                    <Form.Group className='mb-3'>
                                                        <Form.Label>Class</Form.Label>
                                                        <Form.Control type="text" name="name" onChange={(event) => setValue('name', event.target.value)} {...register('name', {
                                                            required: "Name is required"
                                                        })}  autoComplete="off" />

                                                        {errors.name && <span className="error">{errors.name.message}</span> }

                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <p className='dfn_label'>Coordinator</p>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Form.Check
                                                                className="custom-checkbox"
                                                                type="checkbox"
                                                                id="current_coordinator"
                                                                label={currentUser && currentUser.full_name ? currentUser.full_name : 'Current Coordinator'}
                                                                checked={true}
                                                                disabled
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="justify-content-center mt-3">
                                        <Col className='col-auto'>
                                            <button className='cancel_btn' onClick={() => navigate('/coordinator/divisions')} >Cancel</button>
                                        </Col>
                                        <Col className='col-auto'>
                                            <button className='save_btn' type="submit" >Save</button>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Form>
            }
        </>
    )
}

export default CoordinatorAddDivision;